import React, { forwardRef } from 'react'

import { IconProps } from './types'

const Phone = forwardRef<SVGSVGElement, IconProps>(
  ({ size, ...props }, ref) => (
    <svg
      ref={ref}
      width={props.width ?? size}
      height={props.height ?? size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.83333 5.33333L6 2.5H4.66824H2.50125C2.50042 2.55545 2.5 2.61101 2.5 2.66667C2.5 4.64484 3.03021 6.49918 3.95625 8.09533C4.90504 9.73067 6.26935 11.0949 7.90467 12.0437C9.5008 12.9698 11.3551 13.5 13.3333 13.5H13.5V10L10.6667 9.16667L9.4612 10.4223C7.78387 9.58327 6.4167 8.21613 5.57765 6.53879L6.83333 5.33333Z"
        stroke="currentColor"
      />
    </svg>
  ),
)
Phone.displayName = 'Phone'

export default Phone
